<i18n>
{
  "fr": {
    "createRaccordement": "Raccordement",
    "connectedNetwork": "La propriété est raccordée à un réseau",
    "epConnectedPublicSanitationNetwork": "Les eaux pluviales de la propriété sont raccordées à un réseau d’eaux pluviales",
    "propertyRaccordement": "Raccordement de la propriété",
    "addConnection": "Ajouter un branchement",
    "connection": "Branchement - N°{number}",
    "town": "Ville",
    "street": "Rue",
    "streetNumber": "Numéro de police",
    "zip": "Code postal",
    "sameAddressAsProperty": "Adresse du branchement identique à l’adresse de la propriété",
    "connectionNumber": "N° du branchement SIG (après mise à jour SIG)",
    "typeOfConnection": "Type de branchement",
    "networkType": "Type de réseau",
    "networkProperty": "Propriété du réseau",
    "otherNetworkPropertyComment": "Commentaires",
    "throughGargoyle": "Par l’intermédiaire d’une gargouille",
    "visitingAndUncloggingDevice": "Possédant un dispositif de visite et désobstruction",
    "accessibleVisitingDevice": "Dispositif de visite accessible en limite de propriété",
    "commentsRelatingToTheConnection": "Commentaires relatifs au branchement",
    "connectionRequestDate": "Date de la demande de raccordement",
    "quotationNumber": "N° du devis",
    "quotationSendDate": "Date d’envoi du devis",
    "orderNumber": "N° Commande client",
    "orderDate": "Date commande client",
    "invoiceNumber": "N° Facture client",
    "invoiceDate": "Date début de travaux programmée",
    "workDuration": "Durée estimative des travaux",
    "workStartDate": "Date début de travaux programmée",
    "workEndDate": "Date de fin de travaux effective",
    "acceptanceReport": "Procès verbal de réception",
    "connectionInfo": "Informations sur le branchement",
    "connectionWorkInfo": "Informations sur les travaux du branchement"
  }
}
</i18n>

<template>
  <div>
    <div class="panel panel-info">
      <div class="panel-heading">{{ $t('createRaccordement') }}</div>
      <div class="panel-body">
        <Content :title="this.$i18n.t('propertyRaccordement')" :only="true">
          <span slot="main-text-1">
            <b-form-group
              :label="$t('connectedNetwork')"
              label-cols-sm="5"
              label-for="connectedNetwork"
            >
              <b-form-radio-group
                id="connectedNetwork"
                buttons
                v-model="propertyForm.raccordement.connectedNetwork"
                :options="optionsconnectedNetwork"
                size="lg"
                button-variant="outline-info"
                name="connectedNetwork"
                @change="resetInfosSurBranchementFields"
              />
            </b-form-group>
            <b-form-group
              :label="$t('epConnectedPublicSanitationNetwork')"
              label-cols-sm="5"
              label-for="epConnectedPublicSanitationNetwork"
              v-if="propertyForm.raccordement.connectedNetwork == isShown('epConnected') ||propertyForm.raccordement.connectedNetwork == isShown('epConnectedPartially') "
            >
              <b-form-radio-group
                id="epConnectedPublicSanitationNetwork"
                buttons
                v-model="propertyForm.raccordement.epConnectedPublicSanitationNetwork"
                :options="options"
                size="lg"
                button-variant="outline-info"
                name="epConnectedPublicSanitationNetwork"
              />
            </b-form-group>
          </span>
        </Content>
        <template v-if="propertyForm.raccordement">
          <div
            class="panel panel-info"
            v-for="(connection, index) in propertyForm.raccordement.connections"
            :key="index"
            v-on:click="setCurrentElement(index)"
          >
            <div class="panel-heading">
              {{ $t('connection', { number: index + 1 }) }}
              <b-link class="pull-right" @click.stop="deleteConnection(connection)">X</b-link>
            </div>

            <div class="panel-body">
              <filesDropzoneConnection
                name="filesDropzoneConnection"
                :withouPanel="true"
                :indexCol="index"
              />
              <div
                v-if="propertyForm.raccordement.connectedNetwork == isShown('info') || propertyForm.raccordement.connectedNetwork == isShown('epConnectedPartially')"
                class="pb-20"
              >
                <a
                  v-on:click=" collapsedInfoBr = !collapsedInfoBr; currentElement=index"
                  class="collapse-link"
                >
                  <h4 class="header-title" v-b-toggle="'collapse_2' + index">
                    {{ $t('connectionInfo') }}
                    <i class="fa fa-chevron-down"></i>
                    <i class="fa fa-chevron-up"></i>
                  </h4>
                </a>
                <b-collapse :id="'collapse_2' + index" class="mt-2">
                  <b-card>
                    <b-form-group
                      :label="$t('sameAddressAsProperty')"
                      label-cols-sm="5"
                      label-for="sameAddressAsProperty"
                    >
                      <b-form-radio-group
                        buttons
                        v-model="connection.sameAddressAsProperty"
                        :options="options"
                        size="lg"
                        button-variant="outline-info"
                        name="sameAddressAsProperty"
                      />
                    </b-form-group>

                    <b-form-group
                      label-class="required"
                      :label="$t('town')"
                      label-cols="5"
                      v-if="connection.sameAddressAsProperty == isShown('addresse')"
                    >
                      <multiselect
                        v-model="townsProperty[index]"
                        :options="getTowns"
                        @input="setTown"
                        track-by="id"
                        label="label"
                        deselect-label
                        select-label
                        :custom-label="customLabel"
                      />
                    </b-form-group>
                    <b-form-group
                      label-cols="5"
                      label-size="md"
                      v-if="connection.sameAddressAsProperty == isShown('addresse')"
                    >
                      <autocomplete
                        :disableInput="!Boolean(townPropertyBranchement)"
                        input-class="form-control form-control-multi"
                        ref="autocomplete"
                        :source="urlFunction"
                        results-property="features"
                        :results-display="formatDisplay"
                        @selected="setXHRValue"
                        placeholder="veuillez saisir une adresse"
                      ></autocomplete>
                    </b-form-group>

                    <b-form-group
                      :label="$t('town')"
                      label-cols="5"
                      label-size="md"
                      label-for="town"
                      v-if="connection.sameAddressAsProperty == isShown('addresse')"
                    >
                      <b-form-input
                        name="town"
                        type="text"
                        :maxlength="$MAX_255"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.town"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('street')"
                      label-cols="5"
                      label-size="md"
                      label-for="street"
                      v-if="connection.sameAddressAsProperty == isShown('addresse')"
                    >
                      <b-form-input
                        name="street"
                        type="text"
                        :maxlength="$MAX_255"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.street"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('streetNumber')"
                      label-cols="5"
                      label-size="md"
                      label-for="streetNumber"
                      v-if="connection.sameAddressAsProperty == isShown('addresse')"
                    >
                      <b-form-input
                        name="streetNumber"
                        type="number"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.streetNumber"
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('zip')"
                      label-cols="5"
                      label-size="md"
                      label-for="zip"
                      v-if="connection.sameAddressAsProperty == isShown('addresse')"
                    >
                      <b-form-input
                        name="zip"
                        type="number"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.zip"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('connectionNumber')"
                      label-cols="5"
                      label-for="connectionNumber"
                    >
                      <b-form-input
                        name="connectionNumber"
                        type="text"
                        :maxlength="$MAX_255"
                        v-model="connection.connectionNumber"
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('typeOfConnection')"
                      label-cols="5"
                      label-for="typeOfConnection"
                    >
                      <b-form-select
                        name="typeOfConnection"
                        :options="optionsTypeOfConnection"
                        v-model="connection.typeOfConnection"
                        size="sm"
                        plain
                      />
                    </b-form-group>
                    <b-form-group :label="$t('networkType')" label-cols="5" label-for="networkType">
                      <b-form-select
                        name="networkType"
                        v-model="connection.networkType"
                        size="sm"
                        plain
                      >
                        <option
                          v-for="type in getNetworkTypes"
                          :key="type.code"
                          :value="type.internalLabel"
                        >{{ type.internalLabel }}</option>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      :label="$t('networkProperty')"
                      label-cols="5"
                      label-for="networkProperty"
                    >
                      <b-form-select
                        name="networkProperty"
                        v-model="connection.networkProperty"
                        size="sm"
                        plain
                        v-on:change="resetNetworkProperty($event, index)"
                      >
                        <option
                          v-for="type in getNetworkProperties"
                          :key="type.code"
                          :value="type.internalLabel"
                        >{{ type.internalLabel }}</option>
                      </b-form-select>
                    </b-form-group>
                    <b-row>
                      <b-col lg="5"></b-col>
                      <b-col lg="7">
                        <b-form-group
                          :label="$t('otherNetworkPropertyComment')"
                          label-cols="5"
                          label-size="md"
                          label-for="otherNetworkPropertyComment"
                          v-if="connection.networkProperty == isShown('comment')"
                        >
                          <b-form-input
                            name="otherNetworkPropertyComment"
                            type="text"
                            :maxlength="$MAX_255"
                            min="0"
                            size="sm"
                            class="form-control"
                            v-model="connection.otherNetworkPropertyComment"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-form-checkbox
                      plain
                      :name="'throughGargoyle' + index"
                      :id="'throughGargoyle' + index"
                      v-model="connection.throughGargoyle"
                      class="form-group row"
                      v-if="connection.networkType == isShown('throughGargoyle') || connection.id == null"
                    >{{ $t('throughGargoyle') }}</b-form-checkbox>
                    <b-form-group
                      :label="$t('visitingAndUncloggingDevice')"
                      label-cols-sm="5"
                      label-for="visitingAndUncloggingDevice"
                    >
                      <b-form-radio-group
                        buttons
                        v-model="connection.visitingAndUncloggingDevice"
                        :options="options"
                        size="lg"
                        button-variant="outline-info"
                        name="visitingAndUncloggingDevice"
                        v-on:change="resetAccessibleVisitingDevice($event, index)"
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('accessibleVisitingDevice')"
                      label-cols="5"
                      label-for="accessibleVisitingDevice"
                      v-if="connection.visitingAndUncloggingDevice == isShown('accessibleVisitingDevice')"
                    >
                      <b-form-select
                        name="accessibleVisitingDevice"
                        v-model="connection.accessibleVisitingDevice"
                        size="sm"
                        plain
                      >
                        <option
                          v-for="disposal in getVisitDisposals"
                          :key="disposal.code"
                          :value="disposal.internalLabel"
                        >{{ disposal.internalLabel }}</option>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      :label="$t('commentsRelatingToTheConnection')"
                      label-cols="5"
                      label-for="commentsRelatingToTheConnection"
                    >
                      <b-form-input
                        name="commentsRelatingToTheConnection"
                        type="text"
                        :maxlength="$MAX_255"
                        v-model="connection.commentsRelatingToTheConnection"
                      />
                    </b-form-group>
                  </b-card>
                </b-collapse>
              </div>
              <div class="pb-20">
                <a
                  v-on:click=" collapsedInfoTravauxBr = !collapsedInfoTravauxBr"
                  class="collapse-link"
                >
                  <h4 class="header-title" v-b-toggle="'collapse_3' + index">
                    {{ $t('connectionWorkInfo') }}
                    <i class="fa fa-chevron-down"></i>
                    <i class="fa fa-chevron-up"></i>
                  </h4>
                </a>
                <b-collapse :id="'collapse_3' + index" class="mt-2">
                  <b-card>
                    <b-form-group
                      :label="$t('connectionRequestDate')"
                      label-cols-sm="5"
                      label-for="connectionRequestDate"
                      class="form-table"
                    >
                      <b-form-input
                        name="connectionRequestDate"
                        type="date"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.connectionRequestDate"
                      />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </b-form-group>
                    <b-form-group
                      :label="$t('quotationNumber')"
                      label-cols="5"
                      label-size="md"
                      label-for="quotationNumber"
                    >
                      <b-form-input
                        name="quotationNumber"
                        type="text"
                        :maxlength="$MAX_255"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.quotationNumber"
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('quotationSendDate')"
                      label-cols="5"
                      label-size="md"
                      label-for="quotationSendDate"
                      class="form-table"
                    >
                      <b-form-input
                        name="quotationSendDate"
                        type="date"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.quotationSendDate"
                      />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </b-form-group>
                    <b-form-group
                      :label="$t('orderNumber')"
                      label-cols="5"
                      label-size="md"
                      label-for="orderNumber"
                    >
                      <b-form-input
                        name="orderNumber"
                        type="text"
                        :maxlength="$MAX_255"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.orderNumber"
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('orderDate')"
                      label-cols="5"
                      label-size="md"
                      label-for="orderDate"
                      class="form-table"
                    >
                      <b-form-input
                        name="orderDate"
                        type="date"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.orderDate"
                      />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </b-form-group>
                    <b-form-group
                      :label="$t('invoiceNumber')"
                      label-cols="5"
                      label-size="md"
                      label-for="invoiceNumber"
                    >
                      <b-form-input
                        name="invoiceNumber"
                        type="text"
                        :maxlength="$MAX_255"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.invoiceNumber"
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('workStartDate')"
                      label-cols="5"
                      label-size="md"
                      label-for="workStartDate"
                      class="form-table"
                    >
                      <b-form-input
                        name="workStartDate"
                        type="date"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.workStartDate"
                      />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </b-form-group>
                    <b-form-group
                      :label="$t('workDuration')"
                      label-cols="5"
                      label-size="md"
                      label-for="workDuration"
                    >
                      <b-form-input
                        name="workDuration"
                        type="text"
                        :maxlength="$MAX_255"
                        size="sm"
                        class="form-control"
                        v-model="connection.workDuration"
                      />
                    </b-form-group>
                    <b-form-group
                      :label="$t('workEndDate')"
                      label-cols="5"
                      label-size="md"
                      label-for="workEndDate"
                      class="form-table"
                    >
                      <b-form-input
                        name="workEndDate"
                        type="date"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.workEndDate"
                      />
                      <span class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </b-form-group>
                    <b-form-group
                      :label="$t('acceptanceReport')"
                      label-cols="5"
                      label-size="md"
                      label-for="acceptanceReport"
                    >
                      <b-form-input
                        name="acceptanceReport"
                        type="text"
                        :maxlength="$MAX_255"
                        min="0"
                        size="sm"
                        class="form-control"
                        v-model="connection.acceptanceReport"
                      />
                    </b-form-group>
                  </b-card>
                </b-collapse>
              </div>
            </div>
          </div>
        </template>
        <div class="pull-left" v-if="propertyForm.raccordement.connections.length <= 4">
          <b-link class="btn btn btn-cta btn-secondary" @click.stop="addConnection">
            <v-icon name="plus-circle" class="nok" />
            {{ $t('addConnection') }}
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from '../Content';
import Dropzone from '../Dropzone';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import {
  VALUE_YES,
  VALUE_NO,
  PROPERTY_VALUE_OTHERS,
  NETWORK_VALUE_EP,
  CONNECTED_PARTALLY
} from '../../constants/params';
import Autocomplete from 'vuejs-auto-complete';

export default {
  Name: 'RaccordementFields',
  components: {
    Content,
    filesDropzoneConnection: Dropzone,
    Autocomplete,
  },
  props: {
    propertyForm: { required: true },
    collapsedInfoTravauxBrArr: [],
  },
  data: () => ({
    townsProperty: [],
    townProperty: {},
    currentElement: 0,
    townPropertyBranchement: {},
    collapsedInfoBr: { type: Boolean, default: false },
    collapsedInfoTravauxBr: { type: Boolean, default: false },
    optionsconnectedNetwork: [
      { text: 'Oui', value: 'oui' },
      { text: 'Non', value: 'non' },
      { text: 'Partiel', value: 'partiellement' },
    ],
    options: [
      { text: 'Oui', value: 'oui' },
      { text: 'Non', value: 'non' },
      { text: 'Indéterminé', value: 'indetermine' },
    ],
    optionsTypeOfConnection: [
      { text: 'Branchement Neuf', value: 'branchement-neuf' },
      { text: 'Branchement Existant', value: 'branchement-existant' },
      { text: 'Réutilisation de branchement', value: 'reutilisation-branchement' },
    ],
  }),
  computed: {
    ...mapGetters(['getNetworkTypes', 'getNetworkProperties', 'getVisitDisposals', 'getTowns', 'getCities']),
  },
  mounted: function() {
    this.fetchTowns();
    this.fetchCities();
  },
  methods: {
    ...mapActions(['fetchTowns', 'fetchCities']),
    customLabel({ label }) {
      if (label) return label.toUpperCase();
    },
    setCurrentElement(index) {
      this.currentElement = index;
    },
    setTown(value) {
      this.townProperty = value;
    },
    setXHRValue(obj) {
      this.propertyForm.raccordement.connections[this.currentElement].streetNumber =
        obj.selectedObject.properties.housenumber;

      if (obj.selectedObject.properties.city) {
        this.propertyForm.raccordement.connections[this.currentElement].town = obj.selectedObject.properties.city;
      }
      if (obj.selectedObject.properties.street) {
        this.propertyForm.raccordement.connections[this.currentElement].street = obj.selectedObject.properties.street;
      } else {
        this.propertyForm.raccordement.connections[this.currentElement].street = obj.selectedObject.properties.name;
      }
      this.propertyForm.raccordement.connections[this.currentElement].zip = obj.selectedObject.properties.postcode;
      this.$refs.autocomplete.value = this.propertyForm.numberStreet;
      this.$nextTick().then(() => {
        // Add the component back in
        let x = this.propertyForm.complianceSurveyOnly;
        this.propertyForm.complianceSurveyOnly = false;
        this.propertyForm.complianceSurveyOnly = x;
      });
    },
    formatDisplay(result) {
      if (result.properties) return result.properties.label;
    },
    urlFunction(input) {
      if (this.townProperty && this.townProperty.code) {
        let cp = this.getCities.find(p => p.code === this.townProperty.code);
        if (cp) {
          return `${process.env.VUE_APP_BAN_API_URL}/search/?postcode=${cp.postalCode}&q=${input}`;
        }
      }
    },
    getDate(field, index, value) {
      this.propertyForm.raccordement.connections[index][field] = moment(String(value)).format('DD/MM/YYYY');
    },
    addConnection: function() {
      this.propertyForm.raccordement.connections.push({
        sameAddressAsProperty: null,
        town: null,
        street: null,
        streetNumber: null,
        zip: null,
        connectionNumber: null,
        typeOfConnection: null,
        networkType: null,
        networkProperty: null,
        otherNetworkPropertyComment: null,
        throughGargoyle: null,
        visitingAndUncloggingDevice: null,
        accessibleVisitingDevice: null,
        connectionRequestDate: null,
        quotationNumber: null,
        quotationSendDate: null,
        orderNumber: null,
        orderDate: null,
        invoiceNumber: null,
        invoiceDate: null,
        billNumber: null,
        workStartDate: null,
        workDuration: null,
        workEndDate: null,
        acceptanceReport: null,
        attachement: {
          photos: [],
          schemas: [],
          technicalFiles: [],
          reports: [],
          others: [],
        },
      });
    },
    deleteConnection: function(connection) {
      this.propertyForm.raccordement.connections.splice(
        this.propertyForm.raccordement.connections.indexOf(connection),
        1
      );
    },
    isShown: function(value) {
      const options = {
        epConnected: VALUE_YES,
        info: VALUE_YES,
        addresse: VALUE_NO,
        throughGargoyle: NETWORK_VALUE_EP,
        comment: PROPERTY_VALUE_OTHERS,
        accessibleVisitingDevice: VALUE_YES,
        epConnectedPartially: CONNECTED_PARTALLY,
      };
      return options[value];
    },
    resetInfosSurBranchementFields: function(val) {
      if (val === VALUE_NO) {
        const connections = this.propertyForm.raccordement.connections;
        this.collapsedInfoBr = true;

        for (const key in connections) {
          this.propertyForm.raccordement.connections[key].sameAddressAsProperty = null;
          this.propertyForm.raccordement.connections[key].town = null;
          this.propertyForm.raccordement.connections[key].street = null;
          this.propertyForm.raccordement.connections[key].streetNumber = null;
          this.propertyForm.raccordement.connections[key].zip = null;
          this.propertyForm.raccordement.connections[key].connectionNumber = null;
          this.propertyForm.raccordement.connections[key].typeOfConnection = null;
          this.propertyForm.raccordement.connections[key].networkType = null;
          this.propertyForm.raccordement.connections[key].networkProperty = null;
          this.propertyForm.raccordement.connections[key].throughGargoyle = null;
          this.propertyForm.raccordement.connections[key].visitingAndUncloggingDevice = null;
          this.propertyForm.raccordement.connections[key].accessibleVisitingDevice = null;
          this.propertyForm.raccordement.connections[key].otherNetworkPropertyComment = null;
        }
      }
    },
    resetAccessibleVisitingDevice: function(event, index) {
      if (this.propertyForm.raccordement.connections[index].visitingAndUncloggingDevice == 'non') {
        this.propertyForm.raccordement.connections[index].accessibleVisitingDevice = null;
      }
    },
    resetNetworkProperty: function(event, index) {
      if (this.propertyForm.raccordement.connections[index].networkProperty == 'Autres') {
        this.propertyForm.raccordement.connections[index].otherNetworkPropertyComment = null;
      }
    },
  },
};
</script>
<style scoped>
h4[aria-expanded='true'] .fa-chevron-down {
  visibility: hidden;
}
h4[aria-expanded='false'] .fa-chevron-down {
  visibility: visible;
}
h4[aria-expanded='true'] .fa-chevron-up {
  visibility: visible;
}
h4[aria-expanded='false'] .fa-chevron-up {
  visibility: hidden;
}
</style>
